import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { INSGridConfig } from '@norfolk-southern/accessns-components';
import { ColDef, GridOptions } from 'ag-grid-community';

import { NSAccessorialInventoryConstants } from '@ruby/configs/accessorial-inventory.constants';
import { NSCommons } from '@ruby/configs/common.constants';
import { ILeaseTrackResponse } from '@ruby/modules/accessorial-inventory/models/accessorial-inventory.interface';
import { EGridTitle } from '@ruby/shared/enums/grid.enums';

@Component({
  selector: 'ng-monitor-date-dialog',
  templateUrl: './monitor-date.dialog.html',
  styleUrls: ['./monitor-date.dialog.scss']
})
export class MonitorDateDialog {
  monitoredLeaseTrack: ILeaseTrackResponse;
  columns: Array<ColDef>;
  config: INSGridConfig = NSAccessorialInventoryConstants.leaseTrackConfig;
  gridOptions: GridOptions = NSAccessorialInventoryConstants.leaseTrackOptions;
  gridTitle: EGridTitle = EGridTitle.LEASE_TRACK_MONITORED;
  title: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ILeaseTrackResponse) {
    this.monitoredLeaseTrack = data;
    this.columns = NSAccessorialInventoryConstants.leaseTrackOveragesColumnsDef
      .filter((column: ColDef) => column.field !== 'monitoredDate')
      .map((column: ColDef) => column.field === 'equipmentId' ? { ...column, rowGroup: false } : column);
    this.title = `Lease Track Cars Monitored On: ${ NSCommons.formatNSDate(data.monitorDate, 'MM/dd/yyyy') }`;
  }
}
